import React from "react";
import "./Button.scss";
import Spinner from 'react-bootstrap/Spinner';

const Button = ({ name = "name", type = "button", onClick, disabled, loading = false,className='' }) => {
  return (
    <div className="button-container">
      <button
        type={type}
        className={`btn site-primary-btn ${className}`}
        disabled={disabled}
        onClick={onClick}
      >
        {loading ?   <Spinner animation="border"  variant={"light"}/> : name } 
      </button>
    </div>
  );
};

export default Button;
